import { APIsEndPoints } from './../../../utilities/apis.endpoints';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  loggedInUser: any;
  redirectUrl = '/analytics';

  constructor(private http: HttpClient) { }

  login(email: string, password: string) {
    return this.http.post(APIsEndPoints.LOGIN, {email, password})
  }

  logout() {
    return this.http.post(APIsEndPoints.LOGOUT, {})
  }

  sendForgetPasswordLink(email: string) {
    return this.http.post(APIsEndPoints.FORGOT_PASSWORD, {email});
  }

  validateForgotPasswordToken(token: string) {
    return this.http.get(APIsEndPoints.VALIDATE_TOKEN + token)
  }

  setLoggedInUser(user: any) {
    this.loggedInUser = user;
  }

  getLoggedInUser(){
    return this.loggedInUser;
  }

  setRedirectUrl(url) {
		this.redirectUrl = url;
	}

	getRedirectUrl() {
		return this.redirectUrl;
	}

  isLoggedIn() {
		if (!!localStorage.getItem('crewId') && localStorage.getItem('crewId') !== '-1') {
			return true;
		} else {
			return false;
		}
  }
  
}
